import { TextEditable } from './TextEditable';
export { TextEditable } from './TextEditable';

export default TextEditable;
